// imageData.js
// import side_slider_1 from '../../assets/images/side_slider_1.jpg';
// import side_slider_2 from '../../assets/images/basketball_banner_7.jpg';
// import football_side_slider_1 from '../../assets/images/football_side_slider_1.jpg';
// import football_side_slider_2 from '../../assets/images/football_side_slider_2.jpg';
// import creighton_2 from '../../assets/images/creighton_2.webp'
// import creighton_4 from '../../assets/images/creighton_4.jpg'

import bb1 from '../../assets/images/ucla9.png'
import bb2 from '../../assets/images/ucla6.png'


export const sliderImages = [
  {
    id: 1,
    url: bb1
  },
  {
    id: 2,
    url: bb2
  },
];
